enum OnboardingQuestionType {
    TEXT_FIELD = "TEXT_FIELD",
    TIME_HH_MM = "TIME_HH_MM",
    DATE_YYYY_MM_DD = "DATE_YYYY_MM_DD",
    CANADIAN_POSTAL_CODE = "CANADIAN_POSTAL_CODE",
    NUMBER = "NUMBER",
    FILE_TYPE = "FILE_TYPE",
    FILE_TYPE_WITH_EXPIRY = "FILE_TYPE_WITH_EXPIRY",
    DROP_DOWN_SELECT = "DROP_DOWN_SELECT",
    STATIC_TEXT = "STATIC_TEXT"
}

enum ConditionOperator {
    EQUALS = "EQUALS",
    NOT_EQUALS = "NOT_EQUALS",
    CONTAINS = "CONTAINS",
    NOT_CONTAINS = "NOT_CONTAINS",
    GREATER_THAN = "GREATER_THAN",
    LESS_THAN = "LESS_THAN",
    IS_EMPTY = "IS_EMPTY",
    IS_NOT_EMPTY = "IS_NOT_EMPTY"
}

interface SectionConditionResponseDTO {
    readonly targetSectionId: string;
    readonly operator: ConditionOperator;
    readonly expectedValues: readonly string[];
}

interface OnboardingQuestionResponseDTO {
    readonly questionId: string;
    readonly question: string;
    readonly questionType: OnboardingQuestionType;
    readonly required: boolean;
    readonly description?: string | null;
    readonly showSectionsWhen?: readonly SectionConditionResponseDTO[] | null;
    readonly expiryDateEpoch?: string | null;
    readonly options?: readonly string[] | null;
    readonly staticText?: string | null;
}

interface FormSectionResponseDTO {
    readonly sectionId: string;
    readonly sectionTitle: string;
    readonly sectionDescription?: string | null;
    readonly questions: readonly OnboardingQuestionResponseDTO[];
    readonly isDefaultSection: boolean;
}

interface JobberOnboardingTemplateForJobberResponseDTO {
    readonly templateId: string | null;
    readonly templateName: string | null;
    readonly sections: readonly FormSectionResponseDTO[] | null;
}

interface OnboardingAnswerRequestDTO {
    readonly questionId: string;
    readonly questionType: OnboardingQuestionType;
    readonly questionText: string;
    readonly answer?: string | null;
    readonly filename?: string | null;
    readonly expiryDateEpochSeconds?: number | null;
}

interface SubmitOnboardingAnswersRequestDTO {
    readonly templateId: string;
    readonly answers: readonly OnboardingAnswerRequestDTO[];
}

export {
    OnboardingQuestionType,
    OnboardingQuestionResponseDTO,
    JobberOnboardingTemplateForJobberResponseDTO,
    OnboardingAnswerRequestDTO,
    SubmitOnboardingAnswersRequestDTO,
    FormSectionResponseDTO,
    SectionConditionResponseDTO,
    ConditionOperator
};



